module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "lessons text-dark"
  }, [_c('div', {
    staticClass: "lessons__filters"
  }, [_c('Tabs', {
    attrs: {
      "tabs": _vm.tabsList,
      "selected": _vm.activeFilter
    },
    on: {
      "select": _vm.setFilter
    }
  }), _vm._v(" "), _c('DoFiltersFilter', {
    attrs: {
      "title": _vm.$t('vue2.substitution.subject'),
      "tags": _vm.subjectTitles,
      "selectedTags": _vm.selectedSubjectTitles
    },
    on: {
      "select": _vm.toggleSubjectTitle,
      "clear": _vm.clearSubjectTitles
    }
  })], 1), _vm._v(" "), (_vm.isLoading) ? _c('div', [_c('Loader', {
    staticStyle: {
      "margin-top": "10rem"
    },
    attrs: {
      "isSmall": true
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.isLoading && _vm.eventsSortedInDays.length < 1) ? _c('div', {
    staticClass: "no-lessons-text"
  }, [_c('h4', {
    staticClass: "text-explainer"
  }, [(_vm.activeFilter === 'lessonsWithoutSub') ? _c('span', [_vm._v(_vm._s(_vm.$t('vue2.substitution.no_lessons_without_subs')))]) : _vm._e(), _vm._v(" "), (_vm.activeFilter === 'lessonsWithSub') ? _c('span', [_vm._v(_vm._s(_vm.$t('vue2.substitution.no_lessons_with_sub')))]) : _vm._e(), _vm._v(" "), (_vm.activeFilter === '') ? _c('span', [_vm._v(_vm._s(_vm.$t('vue2.substitution.no_lessons')))]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (!_vm.isLoading && _vm.eventsSortedInDays.length > 0) ? _c('div', {
    staticClass: "marg-1-top"
  }, [_c('div', {
    staticClass: "subs-days-container__header"
  }, [_c('p', {
    staticClass: "select-all-item",
    on: {
      "click": _vm.toggleAll
    }
  }, [(_vm.visibleSelectedEventIds.length === 0) ? _c('span', [_vm._v(_vm._s(_vm.$t('vue2.subs_ongoing_absence.select_all')))]) : _c('span', [_vm._v(_vm._s(_vm.$t('vue2.subs_ongoing_absence.unselect_all')))])]), _vm._v(" "), _c('p', {
    staticClass: "select-all-item",
    on: {
      "click": _vm.toggleAll
    }
  })]), _vm._v(" "), _c('ul', {
    staticClass: "subs-days-container rounded shadow"
  }, _vm._l((_vm.eventsSortedInDays), function(day) {
    return _c('li', [_c('div', {
      staticClass: "day__header"
    }, [_c('div', {
      staticClass: "day__header__left"
    }, [_c('label', [_vm._v(_vm._s(_vm.$filters.capitalize(_vm.$filters.ddd(day.date))) + ", " + _vm._s(_vm.$filters.LL(day.date)))]), _vm._v(" "), _vm._l((_vm.getDayAbsenceTimes(day.date)), function(time) {
      return _c('span', {
        staticClass: "badge badge--orange badge--small"
      }, [_vm._v("\n              " + _vm._s(_vm.$t('vue2.user_event_list.absence')) + " " + _vm._s(time) + "\n            ")])
    })], 2)]), _vm._v(" "), _c('ul', {
      staticClass: "sub-lessons"
    }, _vm._l((day.events), function(event) {
      return _c('li', {
        key: event.event_id,
        staticClass: "d-lesson",
        class: {
          'd-lesson--active': _vm.isInEventIdsToAddSub(event.event_id) || (_vm.activeLesson && event.event_id === _vm.activeLesson.event_id)
        },
        style: ({
          'border-color': event.color
        }),
        on: {
          "click": function($event) {
            $event.stopPropagation();
            $event.preventDefault();
            return _vm.toggleEvent(event.event_id)
          }
        }
      }, [_c('div', {
        staticClass: "d-lesson__left"
      }, [_c('div', {
        staticClass: "d-checkbox",
        class: {
          'd-checkbox--active': _vm.isInEventIdsToAddSub(event.event_id)
        }
      }), _vm._v(" "), _c('div', {
        staticClass: "d-lesson__title"
      }, [_c('span', {
        staticClass: "d-lesson__time"
      }, [_vm._v(_vm._s(_vm.$filters.LT(event.start)) + " - " + _vm._s(_vm.$filters.LT(event.end)))]), _vm._v("\n                " + _vm._s(event.title) + "\n                "), _vm._l((_vm.getClasses(event)), function(klass) {
        return _c('span', [_vm._v(", " + _vm._s(klass.name))])
      })], 2)]), _vm._v(" "), _c('div', {
        staticClass: "sub-selector",
        on: {
          "click": function($event) {
            $event.stopPropagation();
          }
        }
      }, [(_vm.getSubstitute(event).length > 0) ? _c('span', {
        staticClass: "icon-users"
      }) : _vm._e(), _vm._v(" "), _vm._l((_vm.getSubstitute(event)), function(sub) {
        return _c('p', {
          staticClass: "sub-name"
        }, [_c('b', [_vm._v(_vm._s(sub.name))]), _vm._v(" "), _c('span', {
          staticClass: "icon-cross2",
          on: {
            "click": function($event) {
              return _vm.setIsAskRemoveAll(true, event, sub)
            }
          }
        })])
      })], 2)])
    }), 0)])
  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.isAskRemoveAll) ? _c('DModal', {
    attrs: {
      "show-close": false
    }
  }, [_c('div', {
    attrs: {
      "slot": "insertComponent"
    },
    slot: "insertComponent"
  }, [_c('div', {
    staticClass: "d-modal__header"
  }, [_c('h2', [_vm._v(_vm._s(_vm.$t('vue2.substitution.remove_sub_from_all_lessons')) + "?")]), _vm._v(" "), _c('div', {
    staticClass: "font-large icon__bg-circle d-modal__header__close",
    on: {
      "click": function($event) {
        return _vm.setIsAskRemoveAll(false, null, null)
      }
    }
  }, [_c('span', {
    staticClass: "icon-cross2"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "d-modal__body"
  }, [_c('h4', [_vm._v(_vm._s(_vm.$t('vue2.substitution.do_you_want_to_remove')) + " " + _vm._s(_vm.activeSub.name) + "\n          " + _vm._s(_vm.$t('vue2.substitution.as_sub_on')) + " \""), _c('span', [_c('span', {
    staticClass: "d-lesson__time"
  }, [_vm._v(_vm._s(_vm.$filters.LT(_vm.activeLesson.start)) + " - " + _vm._s(_vm.$filters.LT(_vm.activeLesson.end)))]), _vm._v(_vm._s(_vm.activeLesson.title)), _vm._l((_vm.getClasses(_vm.activeLesson)), function(klass) {
    return _c('span', [_vm._v(", " + _vm._s(klass.name))])
  })], 2), _vm._v("\" -\n          " + _vm._s(_vm.$t('vue2.substitution.or_on_all_lessons')) + "?\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "d-modal__buttons"
  }, [_c('button', {
    staticClass: "marg-10-right",
    on: {
      "click": _vm.removeSubFromAllLessons
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$t('vue2.substitution.remove_from_all_lessons')) + "\n          ")]), _vm._v(" "), _c('button', {
    staticClass: "submit-button",
    on: {
      "click": _vm.removeSubFromActiveLesson
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$t('vue2.substitution.just_this_lessons')) + "\n          ")])])])])]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6ca3bcd3!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Subs/SubsUserPanel/SubsUserPanelLessons.vue
// module id = 1991
// module chunks = 1